/* eslint-disable @typescript-eslint/no-var-requires */
import { Injectable } from '@angular/core';

const theme = require('../../shared/styles/themes/theme.scss');

@Injectable()
export class ThemesService {

    public styleTag: any;

    constructor() {
        this.createStyle();
        this.injectStylesheet(theme);
    }

    private createStyle() {
        const head = document.head || document.getElementsByTagName('head')[0];
        this.styleTag = document.createElement('style');
        this.styleTag.type = 'text/css';
        this.styleTag.id = 'appthemes';
        head.appendChild(this.styleTag);
    }

    public injectStylesheet(css) {
        this.styleTag.innerHTML = css;
    }

}
